import { useState } from 'react';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import { budgetPlanningTrackerStyle } from '../css/styles/componentStyles';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import AddIcon from '@mui/icons-material/Add';

import "../css/classes/index.css"
import AddProductSidebar from './addProduct/AddProductSidebar';

export default function BudgetPlanningTracker({refreshApi}) {
  const [budgetItems] = useState([
    {
      id: 'expenses',
      title: 'Expenses',
      percentage: 55.1,
      icon: <LocalMallOutlinedIcon size={24} style={{color:"#d10000"}} />,
      color: '#d10000',
      bgColor: '#fff',
      textColor: '#333'
    },
    {
      id: 'bills',
      title: 'Bills',
      percentage: 1.6,
      icon: <DescriptionOutlinedIcon size={24} style={{color:"#00a0c6"}} />,
      color: '#00a0c6',
      bgColor: '#fff',
      textColor: '#333'
    },
    {
      id: 'debts',
      title: 'Debts',
      percentage: 8.0,
      icon: <PercentOutlinedIcon size={24} style={{color:"#0066cc"}} />,
      color: '#0066cc',
      bgColor: '#fff',
      textColor: '#333'
    },
    {
      id: 'savings',
      title: 'Savings',
      percentage: 35.3,
      icon: <SavingsOutlinedIcon size={24} style={{color:'#9c27b0'}} />,
      color: '#9c27b0',
      bgColor: '#fff',
      textColor: '#333'
    }
  ]);

  const remainingPercentage = 0.0;

  return (
    <div className="container-fluid" style={{padding:'16px'}}>
      <div className="row " style={{display:'flex',justifyContent:'space-between',flexWrap:'wrap',alignItems:"center"}}>
        <div className="col-12" style={{marginBottom:'24px'}}>
          {/* Unallocated budget card */}
          {/* <div className="card text-white border-0 shadow" >
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-start">
                <div className='text-start'>
                  <h5 className="fw-bold mb-0">Budget Planning (%)</h5>
                  <h2 className="text-success mt-2 mb-1 display-5 fw-bold">
                    {remainingPercentage.toFixed(1)}%
                  </h2>
                  <p className="text-white mb-0">To be Allocated</p>
                </div>
                <div>
                 <FaExchangeAlt color='text-white-40' />
                </div>
              </div>
            </div>
          </div> */}
        </div>

        <div className='custom-col-md-2 col-6' style={{marginBottom:'8px'}}>
          <div className="card " style={{...budgetPlanningTrackerStyle.budgetPlanningTab, color:'#fff', border:'0',height:'100%'}}>
            <div className="card-body" style={{padding:'18px',textAlign:'left'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'start'}}>
                <div style={{textAlign:'left'}}>
                  <h5 style={{ fontSize: "12px",fontWeight:'700',marginBottom:'0' }}>Budget Planning (%)</h5>
                  <h3 className="display-12" style={{color:'#198754',fontWeight:'700',margin:'8px 0 4px 0'}}>
                    {remainingPercentage.toFixed(1)}%
                  </h3>
                  <p style={{color:'#fff',marginBottom:'0',fontSize:'12.25px'}}>To be Allocated</p>
                </div>
                <div className='' style={{display:'flex',alignItems:'start'}}>
                  <SyncAltIcon style={{color:'#fff'}} size={15} />
                </div>
              </div>
            </div>

          </div>
        </div>
        <div style={{ width: "20px" }} className='hide-custom'><AddIcon style={{color:'#212529'}}/></div>

        {budgetItems.map((item, index) => (
          <>
            <div className="custom-col-md-2 col-6" key={item.id} style={{marginBottom:'8px',height:'100%'}}>
              <div className="card shadow" style={{height:'100%',border:'0'}}>
                <div className="card-body" style={{padding:'8px',textAlign:'left'}}>
                  <div style={{display:'fle',alignItems:'center',marginBottom:'16px'}}>
                    <div style={{marginRight:'16px'}}>
                      {item.icon}
                    </div>
                    <h6 style={{ fontSize: "12px",fontWeight:'700',marginBottom:'0' }}>{item.title}</h6>
                  </div>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <h5 style={{fontWeight:'700',marginBottom:'0'}}>
                      {item.percentage.toFixed(1)}%
                    </h5>
                    {/* {index < budgetItems.length - 1 && (
                    <div className="text-muted fs-3 fw-light">+</div>
                  )} */}
                  </div>
                  <p className="text-muted" style={{fontSize:'12.25px',marginBottom:'0'}}>of your income</p>
                </div>
              </div>
            </div>
            {index !== (budgetItems.length - 1) &&
              <div style={{ width: "20px" }} className='hide-custom'><AddIcon style={{color:'#212529'}} /></div>
            }
          </>
        ))}
      </div>
      
    </div>
  );
}